import { useRef, useState } from 'react';

import { useApiEcomClientError } from '~/src/common/services/error-handler/error-handler';
import Tracker from '~/src/common/services/Tracker';
import { useAddArticleProposal } from '~/src/queries/api-ecom/generated/api-ecom';
import { ApiEcomError } from '~/src/queries/services/client';

const MIN_PROPOSAL_LENGTH = 3;

const useProposalForm = () => {
  const [isSent, setSent] = useState(false);
  const [proposal, setProposal] = useState('');
  const [isInputDisplayed, setInputDisplayed] = useState(false);

  const inputRef = useRef<HTMLInputElement | null>(null);

  const { mutateAsync: proposeArticle, isLoading } = useAddArticleProposal();

  const handleError = useApiEcomClientError();

  const handleSubmit = async () => {
    try {
      Tracker.sendEvent('send proposal', {
        'proposal text': proposal,
      });

      await proposeArticle({ data: { text: proposal } });

      setSent(true);
      setProposal('');
      setInputDisplayed(false);
    } catch (error: unknown) {
      handleError(error as ApiEcomError);
    }
  };

  const handleButtonClick = () => {
    setInputDisplayed(true);
    setSent(false);

    // Permet de laisser le temps à l'input de s'afficher avant de focus dessus
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);

    Tracker.sendEvent('start proposal');
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setProposal(e.target.value);
  };

  const isDisabled = proposal.length < MIN_PROPOSAL_LENGTH || isLoading;

  return {
    isSent,
    isInputDisplayed,
    isLoading,
    handleSubmit,
    handleButtonClick,
    handleInputChange,
    inputRef,
    isDisabled,
  };
};

export default useProposalForm;
